<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="/production-report"
                            v-if="canInventoryReportsProductsView || canSaleView || canInventoryView">
                    <icon name="users-cog"></icon> รายการสั่งผลิตขึ้นรูป </b-nav-item>&nbsp;
                <b-nav-item router-link to="/sheet-report"
                            v-if="canInventoryReportsSheetsView || canInventoryView">
                    <icon name="user-cog"></icon> รายงานการผลิตชีท
                </b-nav-item>&nbsp;
                <b-nav-item router-link to="/machine-product" v-if="canInventoryView">
                    <icon name="cog"></icon> เครื่องขึ้นรูป
                </b-nav-item>&nbsp;
                <b-nav-item router-link to="/machine-sheet" v-if="canInventoryView">
                    <icon name="cogs"></icon> เครื่องผลิตชีท
                </b-nav-item>
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
import {
    canInventoryReportsProductsView,
    canInventoryReportsSheetsView,
    canInventoryView,
    canSaleView
} from "../../util/Permissions"

export default {
    name: "report-layout",
    computed:{
        canInventoryReportsProductsView,
        canInventoryReportsSheetsView,
        canInventoryView,
        canSaleView
    }
}
</script>

<style scoped></style>
